'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UICardSection from 'UIComponents/card/UICardSection';
import UIFlex from 'UIComponents/layout/UIFlex';
import Branding from 'MeetingsBase/models/Branding';
import { getTextColor } from 'MeetingsBase/utils/color';
import styled from 'styled-components';
var ColoredCard = styled.div.withConfig({
  displayName: "ColoredCard",
  componentId: "sc-1juomw9-0"
})(["display:flex;flex-direction:column;justify-content:center;"]);
export default createReactClass({
  displayName: "ColoredCard",
  propTypes: {
    className: PropTypes.string,
    cardSectionClassName: PropTypes.string,
    children: PropTypes.node.isRequired,
    branding: PropTypes.instanceOf(Branding).isRequired
  },
  getPrimaryColorToUse: function getPrimaryColorToUse() {
    var primaryColor = this.props.branding.primaryColor;
    return primaryColor;
  },
  getTextColorToUse: function getTextColorToUse() {
    var primaryColor = this.props.branding.primaryColor;
    return getTextColor(primaryColor);
  },
  getStyle: function getStyle() {
    var primaryColorToUse = this.getPrimaryColorToUse();
    var textColorToUse = this.getTextColorToUse();
    return {
      backgroundColor: primaryColorToUse,
      backgroundImage: 'none',
      color: textColorToUse
    };
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        cardSectionClassName = _this$props.cardSectionClassName,
        children = _this$props.children;
    return /*#__PURE__*/_jsx(UICardWrapper, {
      className: className,
      style: this.getStyle(),
      children: /*#__PURE__*/_jsx(UICardSection, {
        className: cardSectionClassName,
        children: /*#__PURE__*/_jsx(ColoredCard, {
          children: /*#__PURE__*/_jsx(UIFlex, {
            direction: "column",
            children: children
          })
        })
      })
    });
  }
});